/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable camelcase */
/* eslint-disable no-console */
import React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const typographyStyledDescription = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
  marginTop: 1,
  color: "#8C8C8C",
};

const typographyStyledName = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: "1",
  WebkitBoxOrient: "vertical",
};

const cardStyle = {
  card: {
    maxWidth: 200,
    margin: "auto",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.4)",
    borderRadius: "4.44915px",
    background: "#424242",
  },
  cardMedia: {
    // backgroundColor: '#262b32',
    shadow: "none",
    height: { xs: 80, md: 65 },
    objectFit: "contain",
  },
  cardActions: {
    display: "flex",
    justifyContent: "space-between",
    background: "#616161",
  },
};

function Item(props) {
  const { item } = props;
  console.log('Menu API Item: ', item);
  const secondSchemaSize = {
    price: item.price ? item.price : 0,
    name: item.size && item.size[0] ? item.size[0] : "",
    calories: item.calories ? item.calories : 0,
  }
  console.log('secondSchemaSize: ', secondSchemaSize);
  const [size, setSize] = React.useState((item.sizes && item.sizes[0]) ? item.sizes[0] : secondSchemaSize);
  const navigate = useNavigate();
  const itemAddHandler = () => {
    const itemData = {
      image_loc: item.image_loc,
      item_id: item.item_id,
      name: item.name,
      price: size.price,
      quantity: 1,
      size: size.name,
      toppings: item.toppings,
      description: item.description,
      calories: size.calories,
    };
    console.log('itemData: ', itemData);
    localStorage.setItem(
      `/ITEM_VIEW/${itemData.item_id}`,
      JSON.stringify(itemData)
    );
    navigate(`/ITEM_VIEW/${item.item_id}`);
  };
  const handleChange = (event) => {
    console.log("selected size", event.target.value);
    setSize(JSON.parse(event.target.value));
  };
  return (
    <Fade style={{ transformOrigin: "0 0 0" }} timeout={500} in appear>
      <Card sx={cardStyle.card}>
        <CardMedia
          component='img'
          sx={cardStyle.cardMedia}
          src={item.image_loc}
          alt='item_image'
        />
        <CardContent sx={{ textAlign: "center" }}>
          <Typography
            gutterBottom
            variant='h5'
            component='div'
            color='primary.contrastText'
            sx={typographyStyledName}
          >
            {item.name}
          </Typography>
          <Divider light />
          <Typography variant='body2' sx={typographyStyledDescription}>
            {`${size.calories}+ Calories`}
          </Typography>
        </CardContent>
        <CardActions disableSpacing sx={cardStyle.cardActions}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id='demo-simple-select-label'>Size</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={JSON.stringify(size)}
                label='Size'
                onChange={handleChange}
                size='small'
              >
                {item.sizes && item.sizes.map((option) => (
                  <MenuItem key={option.name} value={JSON.stringify(option)}>
                    {`$${option.price} ${option.name}`}
                  </MenuItem>
                ))}
                {(!item.sizes && item.size) && (
                  <MenuItem key={secondSchemaSize.name} value={JSON.stringify(secondSchemaSize)}>
                    {`$${secondSchemaSize.price} ${secondSchemaSize.name}`}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Box>
          <IconButton
            aria-label='add to favorites'
            color='primary'
            onClick={itemAddHandler}
            size='small'
          >
            <AddBoxIcon sx={{ width: 30, height: 30 }} />
          </IconButton>
        </CardActions>
      </Card>
    </Fade>
  );
}

Item.propTypes = {
  item: PropTypes.shape({
    image_loc: PropTypes.string.isRequired,
    item_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    sizes: PropTypes.instanceOf(Array),
    toppings: PropTypes.instanceOf(Array),
    description: PropTypes.string.isRequired,
    price: PropTypes.number,
    size: PropTypes.instanceOf(Array),
    calories: PropTypes.number,
  }).isRequired,
};

export default Item;